import Vue from 'vue'
import App from './App.vue'
import { setupTracking } from '../plugins/setupTracking'

setupTracking()

new Vue({
  render: h => h(App),
}).$mount('#app')
